var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown",
    {
      staticClass: "p-0 btn-group",
      attrs: { id: "lang_choice", variant: "outline-success", "no-caret": "" },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-outline-default waves-effect waves-themed",
                  attrs: { type: "button" },
                },
                [
                  _c("span", { staticClass: "fal fa-globe mr-1" }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.cur_locale.toUpperCase()) +
                      "\n        "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-dropdown-form",
        { staticClass: "change_locale" },
        _vm._l(_vm.locales_list, function (locale) {
          return _c(
            "b-dropdown-item",
            {
              key: locale,
              on: {
                click: function ($event) {
                  return _vm.set_locale(locale)
                },
              },
            },
            [
              _c("span", { staticClass: "fal fa-globe mr-1" }),
              _vm._v(
                "\n            " + _vm._s(locale.toUpperCase()) + "\n        "
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }